// DS: DS4.6
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const ThemeSwitchDark: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <IconWrap disableDefaultColors {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#22272B"
            d="M16 27c6.075 0 11-4.925 11-11S22.075 5 16 5 5 9.925 5 16s4.925 11 11 11z"
          ></path>
          <path
            fill="#F8F8F8"
            fillRule="evenodd"
            d="M16 12c.081 0 .18.005.297.016a.095.095 0 01.028.182 2.667 2.667 0 103.401 3.647.143.143 0 01.272.057L20 16a4 4 0 11-4-4z"
            clipRule="evenodd"
          ></path>
          <path
            fill="#F8F8F8"
            d="M15.111 24.096a1 1 0 111.414-1.414 1 1 0 01-1.414 1.414zm-7-7a1 1 0 111.414-1.414 1 1 0 01-1.414 1.414zm13.707-5.829a1 1 0 10-1.414 1.414 1 1 0 001.414-1.414z"
          ></path>
          <path
            fill="#F8F8F8"
            fillRule="evenodd"
            d="M12.51 21.49c.01.01-.004.04-.033.087l-.081.11-.116.137a3.667 3.667 0 01-.069.074l-2.78 2.926-.29-.224 2.96-2.811.146-.13c.022-.02.044-.038.065-.055l.11-.08c.047-.03.079-.044.088-.034zm14.473-4.888c-.017.32-.048.637-.092.95l-4.704 4.95a.485.485 0 01-.698.009.485.485 0 01.01-.698l5.484-5.21zM16.72 5.023c.154.01.308.024.461.04l-6.935 7.38c-.156.166-.44.142-.635-.054-.196-.195-.22-.48-.054-.635l7.163-6.73z"
            clipRule="evenodd"
          ></path>
          <path
            stroke="#5D5D6C"
            d="M27.5 16c0 6.351-5.149 11.5-11.5 11.5S4.5 22.351 4.5 16 9.649 4.5 16 4.5 27.5 9.649 27.5 16z"
          ></path>
          <circle cx="16" cy="16" r="14" stroke="transparent" strokeWidth="2"></circle>
        </g>
      </svg>
    </IconWrap>
  );
};
ThemeSwitchDark.displayName = 'ThemeSwitchDark';

export default ThemeSwitchDark;
